import React from 'react';

const BenefitSection = () => {
  return (
    <section className="benefit-section-three">
      <div className="bg bg-image bg-pattern-1"></div>
      <div className="auto-container">
        <div className="row">
          
          {/* Content Column */}
          <div className="content-column col-lg-7 col-md-12 col-sm-12 order-lg-2" data-aos="fade-left">
  <div className="inner-column">
    <div className="sec-title light">
      <h2 className="">WHY CHOOSE US</h2>
      <i className="fs-4 text-white pt-3" >
        Experience excellence with SHREE Tours & Travels, your trusted travel partner !
      </i>
    </div>
    <div className="benefit-box">
  <div className="benefit-block-three affordable-pricing">
    <div className="inner-box">
      <div className="number"><span className='hidingn'></span></div>
      <div className="content">
        <h4 className="title pt-4 pt-md-0">Affordable Pricing</h4>
        <div className="text pb-4 pb-md-0">
          SHREE Tours & Travels provides affordable rates for all our services. Enjoy your ride without breaking the bank.
        </div>
      </div>
    </div>
  </div>

  <div className="benefit-block-three faster-booking">
  <div className="inner-box">
    <div className="number"></div>
    <div className="content">
      <h4 className="title pt-4 pt-md-0">Faster Booking</h4>
      <div className="text  pb-4 pb-md-0">
        Booking with SHREE Tours & Travels is quick and easy. Enjoy fast confirmation and hassle-free reservations, whether you're planning ahead or booking last-minute.
      </div>
    </div>
  </div>
</div>


  <div className="benefit-block-three customer-satisfaction">
    <div className="inner-box">
      <div className="number"></div>
      <div className="content">
        <h4 className="title pt-4 pt-md-0">Customer Satisfaction</h4>
        <div className="text pb-4 pb-md-0">
          At SHREE Tours & Travels, customer satisfaction is our top priority. We're committed to providing excellent service every time.
        </div>
      </div>
    </div>
  </div>

  <div className="benefit-block-three availability">
  <div className="inner-box">
    <div className="number"></div>
    <div className="content">
      <h4 className="title pt-4 pt-md-0">24/7 Availability</h4>
      <div className="text  pb-4 pb-md-0">
        At SHREE Tours & Travels, we're available around the clock. No matter the time, you can always count on us for a reliable ride, whenever you need it.
      </div>
    </div>
  </div>
</div>


  <div className="benefit-block-three safety-first">
    <div className="inner-box">
      <div className="number"></div>
      <div className="content">
        <h4 className="title pt-4 ">Safety First</h4>
        <div className="text  pb-4 pb-md-0">
          We prioritize your safety at SHREE Tours & Travels. Our vehicles are regularly maintained to meet the highest safety standards.
        </div>
      </div>
    </div>
  </div>
</div>

    <a href="/booking" className="theme-btn btn-style-one dark-line-two hover-light">
      <span className="btn-title">Book Your Cab</span>
    </a>
  </div>
</div>


          {/* Image Column */}
          <div className="image-column col-lg-5 col-md-12 col-sm-12" data-aos="fade-right">
            <div className="inner-column">
              <figure className="image">
                <img src="images/resource/benefit3-1.png" alt="Image" />
              </figure>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BenefitSection;
